import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreditCard, Lock, Camera, CheckCircle2, Scale, ShieldCheck, HelpCircle } from "lucide-react";

const STEPS = [
  { icon: <CreditCard />, color: "bg-primary/10 text-primary", title: "Du accepterer et bud og betaler", text: "Pengene trækkes på dit kort, men udbetales IKKE til chaufføren endnu. De opbevares sikkert hos Grabber." },
  { icon: <Lock />, color: "bg-amber-50 text-amber-700", title: "Pengene står parkeret sikkert", text: "Chaufføren kan se, at jobbet er betalt, og kan trygt køre ud, men kan ikke røre pengene." },
  { icon: <Camera />, color: "bg-blue-50 text-blue-700", title: "Chaufføren udfører jobbet med fotobevis", text: "Billeder uploades både ved start og aflevering som dokumentation." },
  { icon: <CheckCircle2 />, color: "bg-emerald-50 text-emerald-700", title: "DU godkender, først nu udbetales pengene", text: "Når du trykker 'Godkend', frigives betalingen til chaufføren." },
  { icon: <Scale />, color: "bg-rose-50 text-rose-700", title: "Problemer? Du kan åbne en tvist", text: "Åbn en tvist før du godkender, så kan pengene refunderes til dig." },
];

export default function PaymentFlowInfo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs text-primary hover:underline font-medium"
        data-testid="payment-flow-info-btn"
      >
        <HelpCircle className="w-3.5 h-3.5" /> Hvordan fungerer betalingen?
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="payment-flow-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-primary" /> Tryg betaling</DialogTitle>
            <DialogDescription>Chaufføren får først sine penge, når du har godkendt jobbet.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 mt-2">
            {STEPS.map((s, i) => (
              <div key={i} className="flex gap-3">
                <div className={`w-9 h-9 rounded-xl ${s.color} flex items-center justify-center shrink-0 [&>svg]:w-4 [&>svg]:h-4`}>{s.icon}</div>
                <div>
                  <p className="text-sm font-semibold leading-tight">{i + 1}. {s.title}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-muted-foreground mt-2">Alle betalinger håndteres sikkert af Stripe.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
